
const translations = {
  En: {
    searchTitle: "Welcome to our movie app",
    searchDescription:
      "Millions of movies, TV shows and people to discover. Explore now.",
    searchButton: "Search",
    searchField: "Search and explore...",
    searchPageHeader: "Search Results for:",
    searchPageEmpty: "Movie That you are searching for is not found :/",
    ////
    headerWatchButton: "watchlist",
    ////
    homeHeader: "Popular Movies",
    ////
    notFoundText1: "The page you are looking for is not avaible!",
    notFoundText2: "Looks like you're lost , let's go back Home",
    HomeButton: "Home",
    ////
    watchListHeader: "Watch List",
    emptyWatchListText1: "No Movies in watch list",
    emptyWatchListText2: "Add the movies you are intersted in to appear here",
    ////
    detailsPageDuration: "Duration:",
    detailsPageDurationMin: "Min",
    detailsPageLanguages: "Languages:",
    detailsPageWebsite: "Website",
    detailsPageRecommendations: "Recommendations",
  },
  Ar: {
    searchTitle: "اهلا بكم في تطبيق الافلام الخاص بنا",
    searchDescription:
      "ملايين الأفلام، البرامج التلفزيونية،واشخاص لاستكشافهم، استكشف الآن!",
    searchButton: "بحث",
    searchField: "إبحث واستكشف ...",
    searchPageHeader: "نتائبج البحث عن:",
    searchPageEmpty: "الفيلم الذي تبحث عنه غير مُسجل لدينا :/",
    ////
    headerWatchButton: "قائمة المشاهدة",
    ////
    homeHeader: "اشهر الأفلام",
    ////
    notFoundText1: "الصفحة التي تبحث عنها غير متوفرة!",
    notFoundText2: "يبدو انك تائه، لنعود الى الصفحة الرئيسية :)",
    HomeButton: "الصفحة الرئيسية",
    ////
    watchListHeader: "قائمة المشاهدة",
    emptyWatchListText1: "لا يوجد افلام في قائمة المشاهدات",
    emptyWatchListText2: "اضف الافلام التي تريدها لتظهر هنا.",
    ////
    detailsPageDuration: "المدة:",
    detailsPageDurationMin: "دقيقة",
    detailsPageLanguages: "اللغة:",
    detailsPageWebsite: "الموقع:",
    detailsPageRecommendations: "الترشيحات",
  },
};

export default translations;
